export const columns = () => {
  return [
    {
      title: "Nombre",
      dataIndex: "employee_first_name",
      key: "employee_first_name",
    },
    {
      title: "Apellido",
      dataIndex: "employee_last_name",
      key: "employee_last_name",
    },
    {
      title: "Puesto",
      dataIndex: "position_name",
      key: "position_name",
    },
  ]
}
